'use client'

import {useRouter} from 'next/navigation'
import type {ComponentProps} from 'react'
import {SaveButton} from '@/components/saved/SaveButton'

/**
 * Save, on the university page: once saved, the page shows more (the
 * student's own deadline), so a change re-renders it from the server.
 */
export function StripSaveButton(props: Omit<ComponentProps<typeof SaveButton>, 'onChange'>) {
  const router = useRouter()
  return <SaveButton {...props} onChange={() => router.refresh()} />
}
